<template>
  <div class="flex-col page">
    <div class="flex-col">
      <div class="flex-col relative group_5">
        <div class="self-stretch section_3"></div>
        <span class="self-start font_4 text_5">项目管理申请</span>
        <div
          class="flex-col justify-start items-center self-start text-wrapper btn"
          @click="goProjectApply"
        >
          <span class="font_2 text_6">申请入口</span>
        </div>
        <span class="self-start font_4 text_9">审核状态查询</span>
        <div class="type-box">
          <span
            class="type-btn"
            :class="{active: item.key === selectKey}"
            v-for="(item, index) in typeData"
            :key="index"
            @click="changeTab(item.key)"
          >
            {{item.value}}
          </span>
        </div>
        <div class="flex-col self-stretch relative group_12">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              prop="num"
              label="序号"
              width="88"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="项目名称"
              align="center">
            </el-table-column>
            <el-table-column
              prop="create_time_date"
              label="申请时间"
              align="center">
            </el-table-column>
            <el-table-column
              prop="audit_state"
              label="审核状态"
              align="center">
              <template slot-scope="scope">
                <p class="row">
                  <span
                    class="name"
                    :class="{
                      pass: scope.row.audit_state == 2,
                      unPass: scope.row.audit_state == 3
                    }"
                  >{{scope.row.audit_state_text}}</span>
                </p>
              </template>
            </el-table-column>

            <el-table-column
              v-if="selectKey === '3'"
              prop="audit_state_text"
              label=""
              align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="deleteRecord(scope.row.id)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      selectKey: '1',
      typeData: [
        { key: '1', value: '审核中', active: true },
        { key: '2', value: '审核通过', active: false },
        { key: '3', value: '审核不通过', active: false }
      ],
      tableData: [
      ],
      dataConfig: {
        1: [],
        2: [],
        3: []
      },
      jgmc: '',
      name: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.search()
    },
    async search () {
      // this.$message.success('搜索')
      const res = await this.$https.getXmsqList({
        page: 1,
        limit: 99,
        name: this.name,
        jgmc: this.jgmc
      })
      res.data.data.list.forEach(v => {
        this.dataConfig[v.audit_state].push(v)
      })
      this.tableData = this.dataConfig[this.selectKey]
    },
    changeTab (key) {
      this.selectKey = key
      this.tableData = this.dataConfig[this.selectKey]
    },
    deleteRecord (id) {
      this.$confirm('您确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$https.deleteRecord(id)
        if (res.data.status === 1) {
          this.$message.success('删除成功')
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goProjectApply () {
      this.$router.push('/server?type=8&id=2')
    }
  }
}
</script>

<style scoped lang="less">
  .row .name{
    &.pass{
      color: #00c46d;
    }
    &.unPass{
      color: red;
    }
  }
  .btn{
    cursor: pointer;
  }
  .type-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    margin-top: 33px;
    width: 1066px;

    .type-btn{
      text-align: center;
      width: 104px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid #E5E5E5;

      font-weight: bold;
      font-size: 14px;
      color: #999999;
      line-height: 36px;
      margin-right: 16px;
      cursor: pointer;

      &.active{
        background-color: #006ED1;
        color: white;
      }
    }
  }

  .group_12 {
    width: 1066px;
    margin-top: 20px;
    padding-bottom: 47px;

    /deep/ thead th{
      background: #E8F0FA;
      color: #323232;
    }
    /deep/ .el-table--border, .el-table--group {
      border: 1px solid #bebebe !important;
    }
    /deep/ .el-table--border  td,
    /deep/ .el-table--border th,
    /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
      border-right: 1px solid #bebebe !important;
    }
    /deep/ .el-table--border th.el-table__cell {
      border-bottom: 1px solid #bebebe;
      color: #000000;
    }
    /deep/ .el-table  td, .el-table th.is-leaf  {
      border-bottom: 1px solid #bebebe!important;
    }
    .section_12 {
      padding: 14px 26px;
      background-color: #e8f0fa;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_21 {
        margin-right: 709px;
      }
    }
    .section_18 {
      margin-top: 279px;
      padding: 18px 33px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_28 {
        margin-right: 662px;
      }
    }
    .section_13 {
      padding: 18px 35px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_22 {
        margin-right: 660px;
      }
    }
    .pos_4 {
      position: absolute;
      left: 0;
      right: 0;
      top: 44px;
    }
    .font_9 {
      font-size: 12px;
      font-family: PingFang;
      line-height: 10px;
      color: #333333;
    }
    .section_14 {
      padding: 18px 34px;
      background-color: #f6f6f6;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_23 {
        margin-right: 661px;
        line-height: 11px;
      }
      .text_25 {
        margin-right: 649px;
      }
      .text_29 {
        line-height: 9px;
      }
      .text_30 {
        margin-right: 643px;
      }
    }
    .pos_5 {
      position: absolute;
      left: 0;
      right: 0;
      top: 91px;
    }
    .section_15 {
      padding: 16px 34px 19px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_24 {
        margin-right: 643px;
      }
    }
    .pos_6 {
      position: absolute;
      left: 0;
      right: 0;
      top: 138px;
    }
    .pos_7 {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .section_16 {
      padding: 19px 33px 16px;
      background-color: #ffffff;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_26 {
        margin-right: 674px;
      }
    }
    .pos_8 {
      position: absolute;
      left: 0;
      right: 0;
      top: 232px;
    }
    .section_17 {
      padding: 16px 34px 19px;
      background-color: #f6f6f6;
      border-left: solid 1px #bebebe;
      border-right: solid 1px #bebebe;
      border-top: solid 1px #bebebe;
      border-bottom: solid 1px #bebebe;
      .text_27 {
        margin-right: 661px;
      }
    }
    .pos_9 {
      position: absolute;
      left: 0;
      right: 0;
      top: 279px;
    }
    .pos_10 {
      position: absolute;
      left: 0;
      right: 0;
      top: 372px;
    }
    .image_5 {
      width: 2px;
      height: 421px;
    }
    .pos_3 {
      position: absolute;
      left: 86px;
      bottom: 0;
    }
  }
  .ml-5 {
    margin-left: 5px;
  }
  .ml-203 {
    margin-left: 203px;
  }
  .ml-259 {
    margin-left: 259px;
  }
  .ml-215 {
    margin-left: 215px;
  }
  .ml-83 {
    margin-left: 83px;
  }
  .ml-133 {
    margin-left: 133px;
  }
  .mt-108 {
    margin-top: 108px;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .ml-17 {
    margin-left: 17px;
  }
  .mt-27 {
    margin-top: 27px;
  }
  .ml-99 {
    margin-left: 99px;
  }
  .page {
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 37px;
      .section {
        padding: 53px 0 49px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 39px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 29px;
        }
        .text_3 {
          color: #004290;
          font-size: 32px;
          font-family: Alibaba;
          line-height: 31px;
        }
      }
      .section_2 {
        padding: 16px 362px 16px 388px;
        background-color: #006ed1;
        .group_2 {
          margin-left: 85px;
        }
        .group_3 {
          margin-left: 80px;
        }
        .image_2 {
          width: 13px;
          height: 8px;
        }
        .group_4 {
          margin-left: 81px;
        }
        .image {
          width: 28px;
          height: 32px;
        }
      }
    }
    .group_5 {
      /*padding: 0 240px 142px;*/
      /*.section_3 {*/
        /*background-color: #0067d1;*/
        /*height: 3px;*/
      /*}*/
      /*.text_5 {*/
        /*margin-left: 287px;*/
        /*margin-top: 58px;*/
      /*}*/
      .text-wrapper {
        /*margin-left: 289px;*/
        margin-top: 19px;
        padding: 14px 0;
        background-color: #006ed1;
        width: 181px;
        .text_6 {
          line-height: 15px;
        }
      }
      .text_9 {
        /*margin-left: 288px;*/
        margin-top: 39px;
      }
      .section_6 {
        margin-right: 82px;
        margin-top: 68px;
        background-color: #e5e5e5;
        width: 1068px;
        height: 2px;
      }
      .group_9 {
        margin-top: 19px;
        padding-bottom: 142px;
        .section_7 {
          margin-right: 82px;
          padding: 15px 27px 12px;
          background-color: #e8f0fa;
          width: 1067px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
        }
        .section_8 {
          padding: 18px 34px;
          background-color: #ffffff;
          width: 1067px;
          height: 49px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_11 {
            line-height: 10px;
          }
          .text_12 {
            line-height: 12px;
          }
          .text_13 {
            margin-right: 121px;
            margin-top: -12px;
          }
        }
        .pos_9 {
          position: absolute;
          right: 82px;
          top: 45px;
        }
        .section_9 {
          padding: 18px 34px;
          background-color: #f6f6f6;
          width: 1067px;
          height: 49px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_14 {
            line-height: 12px;
          }
          .text_16 {
            line-height: 10px;
          }
          .text_15 {
            margin-right: 121px;
            margin-top: -12px;
          }
        }
        .pos_10 {
          position: absolute;
          right: 82px;
          top: 91px;
        }
        .font_8 {
          font-size: 12px;
          font-family: PingFang;
          line-height: 9px;
          color: #333333;
        }
        .font_6 {
          font-size: 12px;
          font-family: PingFang;
          line-height: 11px;
          color: #333333;
        }
        .font_7 {
          font-size: 12px;
          font-family: PingFang;
          line-height: 11px;
          color: #00c46d;
        }
        .section_10 {
          padding: 18px 34px;
          background-color: #ffffff;
          width: 1067px;
          height: 50px;
          border-left: solid 1px #bebebe;
          border-right: solid 1px #bebebe;
          border-top: solid 1px #bebebe;
          border-bottom: solid 1px #bebebe;
          .text_17 {
            line-height: 12px;
          }
          .text_18 {
            line-height: 10px;
          }
          .text_19 {
            margin-right: 121px;
            margin-top: -11px;
            line-height: 12px;
          }
        }
        .pos_11 {
          position: absolute;
          right: 82px;
          top: 138px;
        }
        .image_7 {
          width: 2px;
          height: 186px;
        }
        .pos_6 {
          position: absolute;
          left: 378px;
          bottom: 0;
        }
        .image_8 {
          width: 1px;
          height: 186px;
        }
        .pos_8 {
          position: absolute;
          right: 418px;
          bottom: 0;
        }
        .pos_7 {
          position: absolute;
          right: 637px;
          bottom: 0;
        }
      }
      .section_4 {
        padding: 57px 24px 313px;
        background-color: #f9f9f9;
        width: 200px;
        .image_3 {
          width: 18px;
          height: 19px;
        }
        .text_4 {
          line-height: 13px;
        }
        .group_6 {
          margin-top: 32px;
          .image_4 {
            width: 18px;
            height: 20px;
          }
          .text_7 {
            color: #006ed1;
          }
        }
        .group_7 {
          margin-top: 38px;
          padding-left: 33px;
          .image_5 {
            width: 20px;
            height: 20px;
          }
          .text_8 {
            line-height: 13px;
          }
        }
        .group_8 {
          margin-top: 34px;
        }
        .font_5 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 14px;
          color: #666666;
        }
        .group_10 {
          margin-top: 40px;
          .image_6 {
            width: 18px;
            height: 18px;
          }
        }
      }
      .pos {
        position: absolute;
        left: 241px;
        top: 0;
      }
      .section_5 {
        background-color: #006ed1;
        width: 5px;
        height: 37px;
      }
      .pos_2 {
        position: absolute;
        left: 240px;
        top: 103px;
      }
      .text-wrapper_2 {
        padding: 10px 0;
        background-color: #ffffff;
        width: 105px;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
      }
      .pos_3 {
        position: absolute;
        left: 530px;
        top: 227px;
      }
      .font_3 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 14px;
        color: #999999;
      }
      .pos_5 {
        position: absolute;
        left: 770px;
        top: 227px;
      }
      .text-wrapper_3 {
        padding: 10px 0;
        background-color: #006ed1;
        width: 105px;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
        .text_10 {
          color: #ffffff;
        }
      }
      .pos_4 {
        position: absolute;
        left: 650px;
        top: 227px;
      }
    }
    .font_2 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 16px;
      color: #ffffff;
    }
    .image_9 {
      margin-left: 268px;
      width: 26px;
      height: 26px;
    }
    .section_11 {
      padding: 63px 246px 0;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=25da58c86b3a3b684a132279cae20c1d.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .text-wrapper_4 {
        padding: 14px 0;
        background-color: #006ed1;
        width: 164px;
      }
      .group_11 {
        padding: 26px 6px 49px;
        .text-wrapper_5 {
          flex: 1 1 446px;
          padding: 28px 0;
          background-color: #e0edf9;
          height: 75px;
          border-left: solid 1px #006ed1;
          border-right: solid 1px #006ed1;
          border-top: solid 1px #006ed1;
          border-bottom: solid 1px #006ed1;
        }
      }
    }
    .font {
      font-size: 18px;
      font-family: PingFang;
      line-height: 18px;
      color: #ffffff;
    }
    .font_4 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 16px;
      color: #333333;
    }
    .text {
      text-transform: uppercase;
    }
    .section_12 {
      padding: 8px 234px 36px 360px;
      background-image: url('https://ide.code.fun/api/image?token=674dac92797f850011f0a860&name=4d73456eb0616f8bd0f475b81babc110.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .image_10 {
        width: 41px;
        height: 41px;
      }
      .text_20 {
        color: #b2b3b8;
        font-size: 24px;
        font-family: PingFang;
        line-height: 23px;
      }
      .image_11 {
        margin-bottom: 4px;
        width: 40px;
        height: 43px;
      }
      .font_9 {
        font-size: 16px;
        font-family: PingFang;
        line-height: 16px;
        color: #b2b3b8;
      }
      .text_21 {
        line-height: 15px;
      }
      .text_22 {
        color: #006ed1;
        font-size: 24px;
        font-family: PingFang;
        font-weight: 700;
        line-height: 20px;
      }
      .image_12 {
        margin-bottom: 4px;
        width: 31px;
        height: 43px;
      }
      .text_23 {
        color: #006ed1;
        font-size: 20px;
        font-family: PingFang;
        line-height: 19px;
      }
      .section_13 {
        background-color: #2e3142;
        width: 204px;
        height: 188px;
      }
      .font_10 {
        font-size: 14px;
        font-family: PingFang;
        line-height: 11px;
        color: #939598;
      }
      .text_24 {
        margin-left: 3px;
      }
      .text_25 {
        margin-left: 45px;
      }
      .text_26 {
        margin-left: 3px;
      }
    }
  }
</style>
